import React from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Card from "../components/Card";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen bg-[var(--bg-main)]">
      <Sidebar />
      <div className="flex-1 p-4 md:p-8 md:ml-64">
        <div className="mb-6">
          <button
            onClick={() => navigate("/settings")}
            className="mb-4 px-4 py-2 rounded-lg bg-surface-soft text-[var(--text-primary)] hover:bg-surface-soft transition-all"
          >
            Back to Settings
          </button>
          <h1 className="text-3xl md:text-4xl font-bold mb-2 bg-gradient-to-r from-[#22c55e] to-[#16a34a] bg-clip-text text-transparent">
            Privacy Policy
          </h1>
          <p className="text-[var(--text-primary)] text-sm md:text-base">
            How user data is collected, used, and protected.
          </p>
        </div>

        <Card>
          <div className="space-y-4 text-[var(--text-primary)] text-sm">
            <p>
              We collect only data needed to provide account, wallet, trading,
              and support functionality.
            </p>
            <p>
              Personal data is protected using authentication controls and
              secure backend access policies.
            </p>
            <p>
              We do not sell user personal information. Data is used for
              service operations, compliance, and fraud prevention.
            </p>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
